function toast(item: IToast) {
  if (item.description instanceof Error) {
    // A stray Error object passed as description would crash the root ToastContainer
    // ("Objects are not valid as a React child") and white-screen the whole app.
    item.description = item.description.message;
  }
  window.appState.toastStore.addToast(item);
}

const success = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'success',
    title: options.title || gettext('Success'),
    description: message,
  });
};

const error = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Oops. Something went wrong.'),
  });
};

const errorBadRequest = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'error',
    title: options.title || gettext('Error'),
    description: message || gettext('Please correct the highlighted fields.'),
  });
};

const info = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'info',
    title: options.title || gettext('Info'),
    description: message,
  });
};

const warning = (message?: React.ReactNode, options: { title?: string } = {}) => {
  toast({
    type: 'warning',
    title: options.title || gettext('Warning'),
    description: message,
  });
};

const itemSaved = (message?: React.ReactNode) => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was saved successfuly.'),
  });
};

const itemDeleted = (message?: React.ReactNode) => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Item was deleted successfuly.'),
  });
};

const settingsSaved = (message?: React.ReactNode) => {
  toast({
    type: 'success',
    title: gettext('Success'),
    description: message || gettext('Settings were saved successfuly.'),
  });
};

export default {
  success,
  error,
  errorBadRequest,
  warning,
  info,
  itemSaved,
  itemDeleted,
  settingsSaved,
};
